import type { InstanceDetail } from "@keydials/api-client";

/**
 * What the logo editor's Revert button says (KEY-719): it names what clearing this dial's own logo goes back
 * to — an organisation's logo, the dial's default, or the Key Dials mark — rather than a bare "default" that
 * might be somebody else's brand.
 */
export function revertLogoLabel(detail: Pick<InstanceDetail, "centralImageFallbackSource" | "centralImageFallbackOrganisationName">): string {
  switch (detail.centralImageFallbackSource) {
    case "organisation":
      return detail.centralImageFallbackOrganisationName
        ? `Revert to ${detail.centralImageFallbackOrganisationName} logo`
        : "Revert to your organisation's logo";
    case "none":
      return "Revert to the Key Dials logo";
    default:
      // "definition", or an older payload that doesn't say.
      return "Revert to default";
  }
}
